import { render, staticRenderFns } from "./AmountPageOut.vue?vue&type=template&id=12b35720&scoped=true"
import script from "./AmountPageOut.vue?vue&type=script&lang=js"
export * from "./AmountPageOut.vue?vue&type=script&lang=js"
import style0 from "./AmountPageOut.vue?vue&type=style&index=0&id=12b35720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b35720",
  null
  
)

export default component.exports